import React from 'react';
import {
  FaCode,
  FaMobileAlt,
  FaBriefcase,
  FaCogs,
  FaMapMarkerAlt,
  FaLaptop,
  FaLightbulb,
  FaHandshake,
  FaTools,
  FaShieldAlt,
} from 'react-icons/fa';

const Services = () => {
  const services = [
    {
      icon: <FaCode />,
      title: 'Informatique & solutions numériques',
      text: 'Sites web, plateformes digitales, applications métiers et systèmes informatiques complets pour digitaliser vos activités.',
    },
    {
      icon: <FaMobileAlt />,
      title: 'Applications web & mobiles',
      text: 'Applications modernes et performantes, conçues pour les réalités africaines et adaptées à vos utilisateurs.',
    },
    {
      icon: <FaBriefcase />,
      title: 'Ingénierie & IBTP',
      text: 'Études, conception et accompagnement de projets dans les domaines de l\'industrie, du bâtiment et des travaux publics.',
    },
    {
      icon: <FaCogs />,
      title: 'Solutions de gestion & traçabilité',
      text: 'Outils complets pour gérer stocks, ventes, opérations, véhicules et ressources avec suivi en temps réel.',
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'Géolocalisation & tracking',
      text: 'Suivi de véhicules, gestion de flotte et optimisation des déplacements avec visualisation cartographique.',
    },
    {
      icon: <FaLightbulb />,
      title: 'Technologie & innovation',
      text: 'Conception de solutions innovantes, automatisation, digitalisation et intégration de nouvelles technologies.',
    },
    {
      icon: <FaHandshake />,
      title: 'Sous-traitance & services professionnels',
      text: 'Mise à disposition d\'expertises, prestations techniques et accompagnement des entreprises et organisations.',
    },
    {
      icon: <FaLaptop />,
      title: 'Agriculture & technologies agricoles',
      text: 'Solutions technologiques pour moderniser l\'agriculture, améliorer la productivité et faciliter le suivi des activités.',
    },
    {
      icon: <FaTools />,
      title: 'Plateformes & services numériques',
      text: 'Création de plateformes qui connectent les personnes, les entreprises, les prestataires et les opportunités.',
    },
    {
      icon: <FaShieldAlt />,
      title: 'Conseil & accompagnement stratégique',
      text: 'Accompagnement dans la transformation digitale, la planification technologique et le développement de projets.',
    },
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Nos services</span>
          <h2 className="section-title">Des solutions complètes pour votre développement</h2>
          <p className="section-subtitle">
            De la conception au déploiement, nous vous accompagnons à chaque étape
            de vos projets technologiques, numériques et professionnels.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-card-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;